<template>
	<div class="success-page">
		<i class="el-icon-success success-icon"></i>
		<p class="title">支付成功!</p>
		<span class="content">请返回上一页查看，{{ time }}秒后将关闭此页面</span>
	</div>
</template>

<script>
import { postShopifyPayInfo } from '@/utils/api'

export default {
	data() {
		return {
			type: null,
			time: 5,
		}
	},
	mounted() {
		this.postInfo()
		setInterval(() => {
			if (this.time > 0) {
				this.time--
			}
		}, 1000)
		setTimeout(() => {
			window.close()
		}, 5000)
	},
	destroyed() {},
	methods: {
		async postInfo() {
			const query = this.$route.query
			const params = {
				orderno: query.orderno,
				charge_id: query.charge_id,
			}
			await postShopifyPayInfo(params)
		},
	},
}
</script>

<style scoped>
.success-page {
	text-align: center;
	margin-top: 100px;
}
.success-icon {
	font-size: 200px;
	color: #e69752;
}

.title {
	color: #333;
	font-size: 40px;
	padding: 10px 0;
	font-weight: bold;
}

.content {
	color: #666;
	font-size: 18px;
}
</style>
